export default "__VITE_ASSET__CQP2pV7b__"